import React, { useEffect } from 'react'
import { useState } from 'react';
import DownloadTemplateModal from './DownloadTemplateModal';
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import { useLanguage } from '../../Providers/LanguageContext';
import { useUserData } from '../../Providers/UserWrapper';

const ImportDocument = ({ getAllDocument }) => {

    const { language, currentLanguage } = useLanguage()
    const { setIsLoading } = useUserData();

    const [downloadPopup, setDownloadPopup] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);

    const initValue = {
        "typeId": "",
        "file": "",
        "documentName": ""
    }
    const [formValue, setFormValue] = useState(initValue);
    const [typeData, setTypeData] = useState([]); 

    console.log("typeDatadccdf", typeData)

    // handleChange
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValue(prev => ({ ...prev, [name]: value }))
    }

    const toggleDownloadPopup = (e) => {
        e.preventDefault()
        setDownloadPopup(!downloadPopup);
    };

    // handle change file
    const handlePdfUpload = async (e) => {
        const file = e.target.files[0]
        if (file) {
            const data = new FormData();
            data.append("document", file)
            // console.log('imgData',data)
            setIsLoading(true)
            const res = await HttpClient.fileUplode("upload/selfservice-document", "POST", data);
            console.log('imgres', res)
            setIsLoading(false)
            if (res && res.status) {
                setFormValue(prev => ({ ...prev, documentName: res?.originalname, file: res?.url }))
                toast.success("Uploaded SuccessFully!")
            } else {

            }
        }
    }

    // get all type
    const getAllType = async () => {
        const data = {
            "language": "EN" //"ES"
        }
        try {
            const res = await HttpClient.requestData("view/importdocument", "GET", data);
            if (res && res?.status) {
                // Sort the array of objects alphabetically by 'name_EN' for English or 'name_ES' for Spanish
                const sortedData = res.data.sort((a, b) => {
                    const nameA = currentLanguage === "eng" ? a.name_EN.toLowerCase() : a.name_ES.toLowerCase();
                    const nameB = currentLanguage === "eng" ? b.name_EN.toLowerCase() : b.name_ES.toLowerCase();
                    return nameA.localeCompare(nameB);
                });

                // Set the sorted data to state
                setTypeData(sortedData);
            } else {
                toast.error("Failed to fetch types");
            }
        } catch (error) {
            console.error("Error fetching types:", error);
            toast.error("Error fetching types");
        }
    }

    // validation
    const validate = () => {
        if (!formValue.typeId) {
            toast.error("Please Select a Type")
            return true
        }

        if (!formValue.file) {
            toast.error("Please Choose a File")
            return true
        }

        return false
    }

    // handle import
    const handleImport = async (e) => {
        e.preventDefault()
        if (validate()) {
            return
        }
        setIsLoading(true)
        const res = await HttpClient.requestData("add/selfservice-document", "POST", formValue)
        setIsLoading(false)
        if (res && res?.status) {
            setFormValue(initValue)
            toast.success("Document Imported Successfully!")
            getAllDocument();
        } else {
            res.error(res.message || "Something Wrong")
        }
    }

    useEffect(() => {
        getAllType()
    }, [])


    return (
        <>
            <section className='documentManagerslider_sec'>
                <div className='container-fluid'>
                    <div className='task_head'>Document Manager – Import Documents</div>
                </div>
                
                <div className='container-fluid mt-3' style={{
                    border: '4px solid #fff',
                    padding: '40px 20px',
                    borderRadius: '25px',
                }}>




                    {/* <div className='subheadbar'>
                        <h6>Self-Service Document Management</h6>
                    </div> */}

                    <form style={{

                        padding: '10px 20px',
                        borderRadius: '15px',
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        <h6 style={{
                            fontWeight: "600",
                            fontSize: '17px',
                            marginBottom: '20px',
                            color: '#fff'
                        }}>Self-Service Document Management</h6>
                        {/* type */}
                        <div className='d-flex justify-content-between flex-wrap document_form_container'>
                            <div className="form-group d-block document_manager_form_group " style={{
                                width: '48%'
                            }}>
                                <label htmlFor="" style={{
                                    color: '#fff'
                                }}>Type</label>
                                <select
                                    className="form-control"
                                    id=""
                                    name='typeId'
                                    value={formValue.typeId}
                                    onChange={e => handleChange(e)}
                                    style={{
                                        background: '#0c2637',
                                        border: 'none',
                                        color: '#fff',
                                        height: '45px'
                                    }}
                                >
                                    <option style={{
                                        color: '#0c2637',
                                        background: '#fff'
                                    }} disabled selected value={""}>-Select-</option>
                                    {
                                        typeData?.map((item, i) =>
                                            <option style={{
                                                color: '#0c2637',
                                                background: '#fff'
                                            }} key={i} value={item?._id}>
                                                {currentLanguage === "eng" ? item?.name_EN : item?.name_ES}
                                            </option>
                                        )
                                    }
                                </select>
                            </div>

                            {/* file */}
                            <div className="form-group d-block document_manager_form_group" style={{
                                width: '48%',

                            }}>
                                <label htmlFor="Fileinput" style={{
                                    color: '#fff'
                                }} className="">
                                    File
                                </label>

                                <input
                                    style={{
                                        background: '#0c2637',
                                        border: 'none',
                                        color: '#fff',
                                        height: '45px',
                                    }}
                                    type="file"
                                    name="Fileinput"
                                    id="Fileinput"
                                    className="border form-control"
                                    onChange={(e) => handlePdfUpload(e)}
                                />
                            </div>
                        </div>


                        {/* button group */}
                        <div className='allbtn_wrap'>
                            <button
                                className='importdocument_btn'
                                onClick={(e) => handleImport(e)}
                            >
                                Import Document
                            </button>
                            <button
                                className='downloadtemplate_btn'
                                onClick={toggleDownloadPopup}
                            >
                                Download Template
                            </button>
                        </div>

                    </form>
                </div>
                {downloadPopup &&
                    <DownloadTemplateModal
                        handleClose={toggleDownloadPopup}
                        modalIsOpen={downloadPopup}
                    />
                }
            </section>

        </>
    )
}

export default ImportDocument
